import { useQuery } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';

const KASHMIRI_CITIES = ['Srinagar', 'Gulmarg', 'Pahalgam', 'Sonamarg'];

export function useWeather(cities: string[] = KASHMIRI_CITIES) {
  return useQuery({
    queryKey: ['weather', cities],
    queryFn: () => marketplaceService.getWeather(cities),
    staleTime: 5 * 60 * 1000, // 5 min — backend caches 10 min, client caches 5
    retry: 1,
  });
}
